module.exports = __webpack_public_path__ + "img/Home_desktop.754eef79.jpg";